import { render } from "./AppReadMore.vue?vue&type=template&id=5cc1f7f9"
import script from "./AppReadMore.vue?vue&type=script&lang=js"
export * from "./AppReadMore.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Domain\\repos\\quizup.top\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__